import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { PromiseCompletionSource } from "async/PromiseCompletionSource";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { IDiceRollOfferController } from "../controller/IDiceRollOfferController";
import { IDiceRollsOfferModel } from "../model/IDiceRollsOfferModel";
import { DiceRollOfferPage } from "./page/DiceRollOfferPage";
import { BaseScalableView } from "../../../common/BaseScalableView";
import { Web3Model } from "../../../../../web3/models/Web3Model";
import { ILogger } from "../../../../logger/ILogger";
import { StarsResourcePackage } from "../../../common/resources/StarsResourcePackage";
import { DiceRollOfferResourcePackage } from "../resources/DiceRollOfferResourcePackage";
import { DicesResourcePackage } from "../../../common/resources/DicesResourcePackage";
import { IAnalyticProviderWrapper } from "../../../../../analytics/IAnalyticProviderWrapper";

export class DiceRollsOfferPopupView extends BaseScalableView<void> {
    private readonly commonResources: CommonResourcesPackage;
    private readonly starsResources: StarsResourcePackage;
    private readonly dicesResources: DicesResourcePackage;
    private readonly diceRollsOfferResources: DiceRollOfferResourcePackage;
    private readonly diceRollsOfferModel: IDiceRollsOfferModel;
    private readonly diceRollsOfferController: IDiceRollOfferController;
    private readonly web3Model: Web3Model;
    private readonly analyticsProvider: IAnalyticProviderWrapper;
    private readonly logger: ILogger;

    public constructor(
        operationControls: PromiseCompletionSource<void>,
        commonResources: CommonResourcesPackage,
        starsResources: StarsResourcePackage,
        dicesResources: DicesResourcePackage,
        diceRollsOfferResources: DiceRollOfferResourcePackage,
        canvasScaler: ICanvasScaler,
        diceRollsOfferModel: IDiceRollsOfferModel,
        diceRollsOfferController: IDiceRollOfferController,
        web3Model: Web3Model,
        analyticsProvider: IAnalyticProviderWrapper,
        logger: ILogger
    ) {
        super(operationControls, canvasScaler);
        this.commonResources = commonResources;
        this.starsResources = starsResources;
        this.dicesResources = dicesResources;
        this.diceRollsOfferResources = diceRollsOfferResources;
        this.diceRollsOfferModel = diceRollsOfferModel;
        this.diceRollsOfferController = diceRollsOfferController;
        this.web3Model = web3Model;
        this.analyticsProvider = analyticsProvider;
        this.logger = logger;
    }

    public async start(): Promise<void> {
        const diceRollsOfferPageCS = new PromiseCompletionSource<void>();
        const diceRollsOfferPage = new DiceRollOfferPage(
            diceRollsOfferPageCS,
            this.commonResources,
            this.starsResources,
            this.dicesResources,
            this.diceRollsOfferResources,
            this.canvasScaler,
            this.diceRollsOfferModel,
            this.diceRollsOfferController,
            this.web3Model,
            this.analyticsProvider,
            this.logger
        );
        this.addChild(diceRollsOfferPage);
        const result = await diceRollsOfferPageCS.result;
        this.removeChild(diceRollsOfferPage);
        this.operationControls.complete(result);
    }
}
